import * as swcHelpers from '@swc/helpers';
import { reducer as reducer$1, actions } from '@grandvisionhq/state';
import '../types/product.js';
import { SINGLE_PURCHASE } from '../types/purchase-types.js';
import { updateActiveVariant, updatePurchaseType } from './actions.js';

const initialState = {
    activeSku: '',
    selectedPurchaseType: SINGLE_PURCHASE
};
const productDetailContextReducer = reducer$1(initialState, actions.on(updateActiveVariant, (state, action)=>swcHelpers.objectSpread({}, state, {
        activeSku: action.payload.sku
    })
), actions.on(updatePurchaseType, (state, action)=>swcHelpers.objectSpread({}, state, {
        selectedPurchaseType: action.payload.purchaseType
    })
));

export { initialState, productDetailContextReducer };
//# sourceMappingURL=reducer.js.map
